export default "__VITE_ASSET__D$vwmJyj__"